import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  accountInfoEditMode: false,
  accountNameEditMode: false,
  businessDetailsEditMode: false,
  /** SGA = Single Global Account (both SA and ADSP) - isSga Determine if we should display AccountAttributesControllers (Currency/timeZone/Industry) */
  isSga: false,
};

const accountSettingsSlice = createSlice({
  name: 'accountSetting',
  initialState,
  reducers: {
    toggleAccountInfoEditMode: (state) => {
      state.accountInfoEditMode = !state.accountInfoEditMode;
    },
    toggleAccountNameEditMode: (state) => {
      state.accountNameEditMode = !state.accountNameEditMode;
    },
    toggleBusinessDetailsEditMode: (state) => {
      state.businessDetailsEditMode = !state.businessDetailsEditMode;
    },
    setAccountInfoEditMode: (state, action) => {
      state.accountInfoEditMode = action.payload;
    },
    setBusinessDetailsEditMode: (state, action) => {
      state.businessDetailsEditMode = action.payload;
    },
    setIsSga: (state, action) => {
      state.isSga = action.payload;
    },
  },
});

export const {
  toggleAccountInfoEditMode,
  toggleAccountNameEditMode,
  toggleBusinessDetailsEditMode,
  setAccountInfoEditMode,
  setBusinessDetailsEditMode,
  setIsSga,
} = accountSettingsSlice.actions;
export default accountSettingsSlice.reducer;
